import { useState, useCallback, useEffect } from "react";
// Mesmo cliente HTTP + mesmo helper de parsing FireDAC já usados no resto
// do Dashboard (PesquisaGestor, PesquisaClientes, etc). Nada de parsing
// inventado agora — reaproveitando o que já funciona.
import api, { extractFireDACData } from "../services/api";

export const corTipoTransferencia = (tipo = "") => {
  const t = (tipo || "").toLowerCase();
  if (t.includes("saída") || t.includes("saida")) return { cor: "#c0392b", corBg: "#fdecea", corBorda: "#f5b7b1" };
  if (t.includes("entrada")) return { cor: "#1e8e3e", corBg: "#e8f7ee", corBorda: "#a8ddbb" };
  return { cor: "#607d8b", corBg: "#eceff1", corBorda: "#c9d3d8" };
};

// FireDAC às vezes devolve as chaves em maiúsculo dependendo do driver —
// mesmo cuidado que o CarteiraPage já toma com o normalize() dele.
const normalize = (row) => {
  if (!row || typeof row !== "object") return {};
  const out = {};
  for (const [k, v] of Object.entries(row)) out[k.toLowerCase()] = v;
  return out;
};

export const useTransferenciaNotificacoes = () => {
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [marcando, setMarcando] = useState({});
  const [erro, setErro] = useState(null);

  const carregar = useCallback(async () => {
    setLoading(true);
    setErro(null);
    try {
      // Path espelhando o padrão dos outros endpoints do server
      // (PesquisaGestor, PesquisaClientes) — sem prefixo Get/Post na rota,
      // o dispatcher resolve pelo verbo HTTP + nome do procedure.
      const resp = await api.get("/ServerPrincipal/NotificacoesTransferencia");
      const rows = extractFireDACData(resp.data);
      setItens(Array.isArray(rows) ? rows.map(normalize) : []);
    } catch (e) {
      console.error("Erro ao carregar notificações de transferência:", e);
      setErro(e?.response?.data || e?.message || "Erro ao carregar notificações de transferência");
      setItens([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const marcarEntrada = useCallback(async (transId) => {
    setMarcando((m) => ({ ...m, [transId]: true }));
    try {
      await api.post("/ServerPrincipal/AtualizaNotificacoesTransferencia", {
        Entrou: 1,
        Transferencia: transId,
      });
      setItens((prev) => prev.filter((i) => i.trans_id !== transId));
    } catch (e) {
      console.error("Erro ao marcar entrada de transferência:", e);
      throw e;
    } finally {
      setMarcando((m) => {
        const { [transId]: _omit, ...resto } = m;
        return resto;
      });
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const resumoPorTipo = itens.reduce((acc, i) => {
    const tipo = i.trans_tipo || "Outros";
    acc[tipo] = (acc[tipo] || 0) + 1;
    return acc;
  }, {});

  return {
    itens,
    resumoPorTipo,
    total: itens.length,
    totalUrgente: itens.length, // toda transferência pendente é acionável; sem nível de urgência por tempo
    loading,
    marcando,
    erro,
    carregar,
    marcarEntrada,
  };
};

export default useTransferenciaNotificacoes;